import { ReponseEnveloppe } from '../../models/reponses/reponse-enveloppe';

export const reponseEligibilite: ReponseEnveloppe<boolean> = {
    reponse: true
}
